import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import type { QueryClient } from '@tanstack/react-query'
import { routeTree } from '@/routeTree.gen'
import { makeQueryClient } from '@/lib/trpc'

export interface RouterContext {
  queryClient: QueryClient
}

// Start calls getRouter once per SSR request and once in the browser.
// Creating QueryClient here (not at module scope) is the official pattern:
// https://tanstack.com/start/latest/docs/framework/react/guide/routing
// https://github.com/TanStack/router/blob/main/examples/react/start-basic-react-query/src/router.tsx
export const getRouter = () => {
  const queryClient = makeQueryClient()
  const router = createRouter({
    routeTree,
    context: { queryClient },

    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 30_000,
  })

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  })

  return router
}
